export default __webpack_public_path__ + "static/media/mobile_blanco_logo_hyundai.4af4e6e4.svg";